import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <section id="faq" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
          <div className="lg:col-span-1">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-accent-700">
              <i className="ri-question-line"></i>
              常见问题
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              关于观看与缓存的疑问
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              把最常被问到的几个问题整理在一起，点击标题即可展开查看说明。
              如果还有没覆盖到的地方，可以参考其他分区的内容。
            </p>
            <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-5 hidden lg:block">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className="ri-customer-service-2-line text-xl"></i>
              </span>
              <p className="mt-3 text-sm text-foreground-700 leading-relaxed">
                多数播放问题都和网络或线路有关。先切换线路、再检查网速，通常就能解决大半。
              </p>
            </div>
          </div>

          <div className="lg:col-span-2 flex flex-col gap-3">
            {faqs.map((item) => {
              const isOpen = openId === item.id;
              return (
                <div
                  key={item.id}
                  className={`rounded-lg border transition-colors ${
                    isOpen
                      ? "border-primary-300 bg-background-100"
                      : "border-background-200 bg-background-50"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenId(isOpen ? null : item.id)}
                    aria-expanded={isOpen}
                    aria-controls={`faq-panel-${item.id}`}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="text-sm md:text-base font-medium text-foreground-950">
                      {item.q}
                    </span>
                    <span
                      className={`w-7 h-7 flex items-center justify-center rounded-full shrink-0 transition-colors ${
                        isOpen
                          ? "bg-primary-500 text-background-50 dark:text-foreground-950"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div
                      id={`faq-panel-${item.id}`}
                      className="px-5 pb-4 -mt-1 text-sm text-foreground-600 leading-relaxed"
                    >
                      {item.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}